import './section.css';
import PhoneIcon from '@mui/icons-material/Phone';

const Section = () => {
  return (
    <div className="sectionBar">
      <h3>Encomende já!</h3>
      <h4><PhoneIcon />  21 98077 3683</h4>
    </div>
  )
}

export default Section